<script setup>
import { computed } from "vue";
import { useRoute } from 'vue-router'
import CreateClient from './CreateClient.vue';
import EditClient from "./EditClient.vue";

const route = useRoute()

const showCreateClient = computed(() => {
  return route.name === 'DashboardClientCreate';
});

const showEditClient = computed(() => {
  return !showCreateClient.value && (route.name === 'DashboardClients' || route.name === 'DashboardClientEdit');
});

console.log("DASHBOARD CLIENTS");
</script>
<template>
    <div class="ml-4" style="width: 100%">
    <div class="px-4" style="width: 100%">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="dashboard-title">Clientes</h2>
        <router-link
          v-if="route.name === 'DashboardClients'"
          :to="{ name: 'DashboardClientCreate' }"
          class="btn btn-primary globals-button"
        >
          Crear Cliente
        </router-link>
      </div>
      <CreateClient v-if="showCreateClient" :route="route" ></CreateClient>
      <EditClient v-if="showEditClient" :route="route" ></EditClient>
        </div>
    </div>
</template>
<style scoped>
</style>
